import React from 'react';
import { ComponentSkinProps } from '../../../../types/component-skin';
import { BenefitSummaryLogicReturn } from '../BenefitSummaryLogic';
import '../BenefitSummary.css';

/**
 * BenefitSummary 컴포넌트의 기본 스킨
 */
const BasicBenefitSummarySkin: React.FC<BenefitSummaryLogicReturn> = ({
    // Props
    title,
    emptyText,
    style,
    className,
    
    // State
    items,
    loading,
    error,
    totalAmount,
    
    // Functions
    formatKoreanDate,
    
    // Utils
    t
}) => {
  // Extract skin options with defaults
  const {
    showTotal = true,
    useKoreanDateFormat = true,
    headerBackground = '#f8f9fa',
    headerTextColor = '#495057',
    positiveAmountColor = '#28a745',
    negativeAmountColor = '#dc3545',
    tableStyle = 'basic' as string
  } = {};

  // Table style class
  const tableClassName = `benefit-summary-table-container ${tableStyle === 'bordered' ? 'bordered' : ''} ${tableStyle === 'striped' ? 'striped' : ''}`;

  // Loading state
  if (loading) {
    return (
      <div className={`benefit-summary-container ${className}`} style={style}>
        <h2 className="benefit-summary-title">{title}</h2>
        <div className="benefit-summary-loading">
          <div className="benefit-summary-spinner"></div>
          {t('로딩 중...')}
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className={`benefit-summary-container ${className}`} style={style}>
        <h2 className="benefit-summary-title">{title}</h2>
        <div className="benefit-summary-error">
          {t('데이터를 불러오는데 실패했습니다.')} {error}
        </div>
      </div>
    );
  }

  return (
    <div className={`benefit-summary-container ${className}`} style={style}>
      <h2 className="benefit-summary-title">{title}</h2>
      
      <div className={tableClassName}>
        {/* Table header */}
        <div 
          className="benefit-summary-header"
          style={{ backgroundColor: headerBackground, color: headerTextColor }}
        >
          <div className="bs-col date">{t('날짜')}</div>
          <div className="bs-col category">{t('카테고리')}</div>
          <div className="bs-col amount">{t('금액')}</div>
        </div>
        
        {/* Table content */}
        {items.length === 0 ? (
          <div className="benefit-summary-empty">{emptyText}</div>
        ) : (
          <>
            {items.map((item: any) => (
              <div key={item.id} className="benefit-summary-item">
                <div className="bs-col date">
                  {useKoreanDateFormat ? formatKoreanDate(item.summaryDate) : item.summaryDate}
                </div>
                <div className="bs-col category">
                  {item.extraPresetStep?.name || '-'}
                </div>
                <div 
                  className="bs-col amount"
                  style={{ 
                    color: item.amount >= 0 ? positiveAmountColor : negativeAmountColor 
                  }}
                >
                  {item.amount >= 0 && '+'}{item.amount?.toLocaleString() || '0'}
                </div>
              </div>
            ))}
            
            {/* Table footer - total */}
            {showTotal && (
              <div className="benefit-summary-footer">
                <div className="bs-col total-label">{t('합계')}</div>
                <div 
                  className="bs-col total-amount"
                  style={{ 
                    color: totalAmount >= 0 ? positiveAmountColor : negativeAmountColor 
                  }}
                >
                  {totalAmount >= 0 && '+'}{totalAmount.toLocaleString()}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BasicBenefitSummarySkin;